"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class PersonIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M14.6185833,10.6898333 C15.0899167,10.2441667 15.0555,9.27058333 14.6734167,8.93983333 C14.9773333,8.13191667 15.367,7.19158333 15.2025,6.36791667 C15.0000833,5.35816667 13.5668333,5 12.4001667,5 C11.4954167,5 10.3964167,5.22808333 10.0499167,5.85225 C9.70108333,5.89075 9.43216667,6.03541667 9.249,6.28216667 C8.74208333,6.96583333 9.08858333,8.01525 9.33708333,8.92875 C8.95558333,9.26008333 8.91008333,10.2441667 9.38083333,10.6898333 C9.44558333,11.6161667 9.99333333,12.18375 10.25,12.4013333 L10.25,13.806 C10.0038333,13.8975833 9.7635,13.9856667 9.52958333,14.072 C7.50483333,14.8163333 6.04183333,15.35475 5.61366667,16.2116667 C5.00641667,17.4255833 5,18.6564167 5,18.7083333 C5,18.8693333 5.13066667,19 5.29166667,19 L18.7083333,19 C18.8693333,19 19,18.8693333 19,18.7083333 C19,18.6564167 18.993,17.4255833 18.38575,16.2116667 C17.957,15.3541667 16.494,14.8163333 14.46925,14.072 C14.2353333,13.9856667 13.995,13.8975833 13.75,13.806 L13.75,12.4013333 C14.0060833,12.18375 14.5538333,11.6161667 14.6185833,10.6898333" })))));
    }
}
exports.PersonIcon = PersonIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/person.tsx
// module id = 2157
// module chunks = 0 1 2